import React from 'react'
import Modal from 'material-ui/Modal'
import Paper from 'material-ui/Paper'
import Typography from 'material-ui/Typography'
import Icon from 'material-ui/Icon'
import { toast } from 'react-toastify'
import { APP_CONFIG } from '../../../config'
import Button from 'material-ui/Button'
import Input, { InputLabel } from 'material-ui/Input'
import { FormControl, FormHelperText } from 'material-ui/Form'
import TextField from 'material-ui/TextField';
import Tooltip from 'material-ui/Tooltip'

import Grid from 'material-ui/Grid'
import List, { ListItem, ListItemText } from 'material-ui/List'

import { withStyles } from 'material-ui/styles'
import styles from './styles'

import { ModalHeader, ModalContents, ModalFooter } from '../../common/modal'

class LantekUpload extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      cometfiles: null,
      errors: {},
      error: '',
      saveJob: false,
      allowedExtensions: '',
      maxFileSize: 0,
    }
    this.handleClose = this.handleClose.bind(this)
    this.handleUpload = this.handleUpload.bind(this)
    this.handleChange = this.handleChange.bind(this)

  }

  componentDidMount() {
    const { fileUploadSettings } = this.props;
    if (fileUploadSettings && fileUploadSettings.allowedCometExtensions) {

      // fileUploadSettings.allowedCometExtensions is an array of strings
      // Add a dot to the beginning of each string if it doesn't already have one
      const allowedCometExtensions = fileUploadSettings.allowedCometExtensions.map(ext => {
        if (ext[0] !== '.') {
          return '.' + ext
        }
        return ext
      });

      this.setState({
        allowedExtensions: allowedCometExtensions,
        maxFileSize: fileUploadSettings.maxFileSize || APP_CONFIG.maxFileUploadSize
      })
    }
  }

  handleClose() {
    this.props.onClose()
  }

  edit = () => {
    this.setState({
      saveJob: true
    })
  }

  save = () => {
    const { jobName } = this.state
    if (!jobName) {
      this.setState({
        errors: {
          jobName: true
        }
      })
      return;
    }
    this.props.validateLt4JobName(jobName).then(isUniqueJobName => {
      if (!isUniqueJobName) {
        this.setState({
          error: 'duplicate_job'
        })
      } else {
        this.setState({
          saveJob: false,
          error: ''
        })
      }
    }).catch(ex => {
      console.log(ex)
    })
  }

  handleUpload() {
    const { jobName, cometfiles } = this.state;
    if (!jobName || !cometfiles) {
      this.setState({
        errors: {
          jobName: true,
          cometfiles: true
        }
      })
      return;
    }
    let fd = new FormData();
    Object.keys(cometfiles).forEach(key => {
      fd.append('file', cometfiles[key])
    });
    fd.append('jobName', jobName)
    this.props.onUpload(fd)
  }

  async handleChange(e) {
    if (e.target.type == 'file' && e.target.files.length) {
      const totalBytes = Object.keys(e.target.files).reduce((total, file) => (total + e.target.files[file].size), 0)
      // 1 MB = 1048576 bytes

      const { fileUploadSettings } = this.props;

      const fileSizeInMB = Math.round(totalBytes / 1048576);
      const maxAllowedFileSizeInMB =  fileUploadSettings.maxFileSize || APP_CONFIG.maxFileUploadSize;
      const allowedExtensions = fileUploadSettings.allowedCometExtensions;

      if (fileSizeInMB >= maxAllowedFileSizeInMB) {
        toast.error(` ${this.props.translate("jobs_upload_file_size_error", { value: maxAllowedFileSizeInMB })}`, {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
        })
        document.getElementById("cometfiles").value = "";
        this.setState({
          cometfiles: null
        })
        return
      }

      if (allowedExtensions && allowedExtensions.length) {
        const fileName = e.target.files[0].name;
        const fileExtension = fileName.split('.').pop().toLowerCase();
        if (!allowedExtensions.includes(fileExtension)) {
          toast.error(` ${this.props.translate("jobs_upload_file_extension_error", { value: allowedExtensions.join(', ') })}`, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
          })
          document.getElementById("cometfiles").value = "";
          this.setState({
            cometfiles: null
          })
          return
        }
      }


      let jobname = e.target.files[0].name.substring(0, e.target.files[0].name.indexOf(".zip"))
      this.setState({
        [e.target.name]: e.target.files,
        jobName: jobname,
        saveJob: false
      })

      this.props.validateLt4JobName(jobname).then(isUniqueJobName => {
        if (!isUniqueJobName) {
          this.setState({
            error: 'duplicate_job'
          })
        } else {
          this.setState({
            error: ''
          })
        }
      }).catch(ex => {
        console.log(ex)
      })
    } else {
      this.setState({
        [e.target.name]: e.target.value,
        errors: {
          jobName: false
        }
      })
    }
  }

  render() {
    const {
      classes,
      translate
    } = this.props

    const {
      cometfiles,
      errors,
      error,
      jobName,
      saveJob
    } = this.state

    let $fileLists = (cometfiles && cometfiles.length) ? (
      <React.Fragment>

        {!saveJob && (<Grid container style={{ marginTop: '30px' }}>
          <Grid item xs={12} sm={6}>
            <Typography type="caption">{translate('generate_report_report_jobname')}</Typography>
          </Grid>
        </Grid>)}

        <List disablePadding={true} className={classes.scrollableList}>

          {(jobName && !saveJob) ? (<React.Fragment>
            <ListItem key={`jobname`}><ListItemText className={classes.truncatelongjobname} primary={jobName} />
              <Button aria-label="Create Job" className={classes.button} fab mini onClick={this.edit}>
                <Icon>edit</Icon>
              </Button>
            </ListItem>
          </React.Fragment>) : null}

          {saveJob ? (<React.Fragment>
            <div>
              <TextField
                className={classes.textField}
                required
                fullWidth
                error={errors.jobName ? true : false}
                name="jobName"
                label={translate("generate_report_report_jobname")}
                margin="normal"
                value={jobName}
                onChange={this.handleChange}
                helperText={errors.jobName ? translate("formfield_error_general_required") : translate("generate_report_report_jobname")}
              />
              <Button aria-label="Create Job" className={`${classes.button} ${classes.save}`} fab mini onClick={this.save}>
                <Icon>save</Icon>
              </Button>
            </div>
          </React.Fragment>) : null}
        </List>

        <Grid container style={{ marginTop: '30px' }}>
          <Grid item xs={12} sm={6}>
            <Typography className={ classes.modalHeader } type="caption">{translate('job_upload_comet_title')}</Typography>
          </Grid>
        </Grid>
        <List disablePadding={true} className={classes.scrollableList}>
          {
            Array.from(cometfiles).map((val, i) => {
              return (<ListItem key={`testfilenames-${i}`}><ListItemText primary={val.name} /></ListItem>)
            })
          }
        </List>
      </React.Fragment>
    ) : (null)

    return (
      <Modal open={true} onClose={this.handleClose.bind(this)}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography type="headline" color="inherit" className={classes.modalHeader}>
                {translate('job_upload_comet_title')}
              </Typography>
              <Button
                className={classes.close}
                onClick={this.handleClose}
              >
                <Icon>clear</Icon>
              </Button>
            </ModalHeader>
            <ModalContents>
              {error && error == "duplicate_job" && (<div className={classes.warning}>
                <Typography type="subheading" color="inherit">
                  {translate('general_warning')}
                </Typography>
                <Typography type="body1" color="inherit">
                  {translate('comet_job_upload_is_duplicate_job')}
                </Typography>
              </div>)}
              < form noValidate autoComplete="off" className={classes.form}>
                <FormControl
                  fullWidth
                  error={errors.cometfiles ? true : false}
                >
                  <Input
                    className={classes.upload}
                    id="cometfiles"
                    type="file"
                    name="cometfiles"
                    onChange={this.handleChange}
                    inputProps={{
                      name: "cometfiles",
                      multiple: false,
                      accept: this.state.allowedExtensions ? this.state.allowedExtensions.join(',') : null
                    }}
                  />
                  <FormHelperText id="cometfiles-helper-text">{translate('job_upload_comet_helptext')}</FormHelperText>
                  <FormHelperText id="cometfiles-helper-text-2">{translate("security_file_upload_settings_allowed_comet_extensions")}: {this.state.allowedExtensions ? this.state.allowedExtensions.join(',') : null}</FormHelperText>
                  <FormHelperText id="cometfiles-helper-text-3">{translate("security_file_upload_settings_max_file_size")}: {this.state.maxFileSize ? this.state.maxFileSize : null} MB</FormHelperText>
                </FormControl>
                {$fileLists}
              </form>

            </ModalContents>
            <ModalFooter classes={classes}>

              {(cometfiles && cometfiles.length) ? (<Button
                className={classes.submit}
                raised
                color="primary"
                type="submit"
                disabled={(error == "duplicate_job") || saveJob}
                onClick={this.handleUpload}
              >
                {translate('general_import')}
              </Button>) : null}
            </ModalFooter>
          </Paper>
        </div>
      </Modal >
    )
  }
}
export default withStyles(styles)(LantekUpload)



// WEBPACK FOOTER //
// ./src/components/jobs/cometupload/index.js